const TourPlan = {

    // FIELDS
    "sales_person": "Sales Person",
    "type": "Type",
    "day": "Day",
    "date": "Date",
    "customer": "Customer",
    "grade": "Grade",
    "city": "City",
    "address": "Address",
    "action": "Action",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "tour_plan": "Tour Plan",

    // ERROR
    "error_sales_person": "Select Sales Person",
    "error_type": "Select Type",
    "error_day": "Select Day",
    "error_date": "Choose Date",
    "error_min_customer": "Add Atleast One Customer",
    "error_customer_nf": "Customer Not Found",

    // TABLE HEADER
    "table_sales_person": 'SALES PERSON',
    "table_day": 'DAY',
    "table_date": 'DATE',
}

export default TourPlan;